module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAMAAACfWMssAAAAYFBMVEUAAAAYq/MWqfEUqfIUqPEWrPIUqfEUqPAUqfEUqPEVqPEVqfIUqfEarfcVqfAUqfEUqfEVqfAVqfEVqfEUqfAVqvIWq/IWqvIYr/cVr/UVqPEVqPEWqfEYqvMas/8UqPCR7wcKAAAAH3RSTlMAQIBj7if489fMqIVtHdHKsqymj4leSzogGLaTghUKAATJNAAAAH9JREFUSMft1ckKgCAUhWGtbJ7n2fd/y6joRrRIDcHF/bbyc3F1CEJaDV0zl5kjUSTUrovU4yehhMVV7rv84etGFAYOsfjhO1xZG08j3BAPr0cMMTQ9pE+kp2/KoSF/xBBDtZCwFmbmDvWNzhuDYZQJwXDch2GVtnSNtU85Qj9tJBt2xlJ8H48AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/homeSVG/svg_window.png
// module id = 9uQj
// module chunks = 2